<template>
  <WizardTempWifiConnectStep
    v-if="wizardStep === 1"
    :handleNextStep="onNextStepClick"
    title="온도조절기 교체"
  />
</template>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
  onMounted,
  onBeforeUnmount,
  onBeforeMount,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';
import { DeviceDefault, SettingConfig } from '@/common/constants';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import WizardTempWifiConnectStep from './components/wizard/WizardTempWifiConnectStep';
import WizardTempDeviceRegistStep from './components/wizard/WizardTempDeviceRegistStep';
import WizardTempRegistCompleteStep from './components/wizard/WizardTempRegistCompleteStep';

const { emitter, mobile, mqtt } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const router = useRouter();
const route = useRoute();
const mqttControl = reactive(useMqttControl());

const wizardStep = ref(1);
const serialCode = ref('');
const forceRoute = ref(false);
const ap_wifi = ref({
  ssid: '',
  password: 'inshow75'
});

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'온도조절기 교체',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});

onMounted(() => {
  forceRoute.value = false;
});

onBeforeUnmount(() =>{
  if (ap_wifi.value.ssid) {
    mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
  }
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
});

const zones = computed(() => store.getters['home/getZones']);
const zone = computed(() => store.getters['home/getCurrentZone']);

const setSettingModeOff = async () => {
  if (!zone.value) return;
  forceRoute.value = true;
  const payload = { isEditMode: false };
  const result = await Axios.patch(
    ZoneApi.UPDATE_ZONE.replace(':id', zone.value._id),
    payload,
  );
  if (result.resultCode === '0000') {
    mqttControl.onPublishZone(zone.value._id, payload);
    store.dispatch('home/fetchAllZones');
  }
};

onBeforeRouteLeave((to, from) => {
  // forceRoute가 true인 경우 (프로그래밍 방식으로 이동하는 경우)는 확인 없이 허용
  if(forceRoute.value) {
    forceRoute.value = false;
    if (ap_wifi.value.ssid) {
      mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
    }
    return true;
  }

  // 사용자가 직접 뒤로 가기나 다른 경로로 이동하려는 경우 확인 다이얼로그 표시
  return new Promise((resolve) => {
    if (store.getters["isLoading"]) {
      emitter.emit('showPopConfirm', {
        description: '세팅이 진행중입니다.\n절차를 중지하고 세팅모드를 종료하시겠습니까?',
        okCallback: async () => {
          emitter.emit('hideLoading', true);
          if (ap_wifi.value.ssid) {
            mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
          }
          forceRoute.value = false;
          resolve(true);
        },
        cancelCallback: () => {
          resolve(false);
        },
      });
    } else {
      // 세팅모드 종료 - Toast로 표시
      (async () => {
        await setSettingModeOff();
        if (ap_wifi.value.ssid) {
          mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
        }
        forceRoute.value = false;
        emitter.emit('showPopToast', {
          description: '세팅모드가 종료되었습니다.',
          type: 'success',
          autoHide: true,
          delay: 3000,
        });
        resolve(true);
      })();
    }
  });
});
// 컨트롤러 교체 :
const onChange = async () => {
  console.log("onChange");
  const request = () => {
    return new Promise(async (resolve, reject) => {
      setTimeout(async () => {
        try {
          const controllerId = serialCode.value.slice(0, serialCode.value.indexOf("-"));
          const connectedController = {
            _id: controllerId,
            // model에 QR 시리얼을 넣지 않음 (서버/MQTT Version의 T0x 사용)
            version: 1,
            isTempController: true
          };
          
          console.log(CtrlApi.CHANGE_CTRL.replace(':id', route.params.id));
          console.log(connectedController);

          const result = await Axios.patch(
            CtrlApi.CHANGE_CTRL.replace(':id', route.params.id),
            connectedController,
          );
          resolve(result);
        } catch (e) {
          resolve(e);
        }
      }, SettingConfig.requestInterval);
    });
  }

  console.log("onChange2");
  return new Promise(async (resolve, reject) => {
    try {
      let result = undefined;
      console.log("onChange3");
      for (let i = 0; i < SettingConfig.requestCount; i++) {
        console.log("onChange4");
        emitter.emit('setLoadingText', i === 0 ? '온도조절기 정보를 교체중입니다.' : `온도조절기 정보를 ${i + 1}번째 교체 시도하고 있습니다.`);
        result = await request();
        if (result?.resultCode === "0000") {
          resolve();
          return;
        }
      }
      
      reject(result?.resultMessage?.length > 0 ? result.resultMessage : "온도조절기 교체에 실패했습니다.");
      emitter.emit('hideLoading', true);
    } catch (e) {
      console.log(e);
      reject("온도조절기 교체 중 오류가 발생하였습니다.")
      emitter.emit('hideLoading', true);
    }
  });
};

const onNextStepClick = async (params) => {
  try {
    if (wizardStep.value === 1) {
      serialCode.value = params.serialCode;
      // WiFi 연결 정보 업데이트
      if (serialCode.value) {
        ap_wifi.value = {
          ssid: serialCode.value,
          password: 'inshow75'
        };
      }

      emitter.emit('showLoading');
      await onChange();
      emitter.emit('hideLoading', true);
    
      await store.dispatch('home/fetchAllZones');

      emitter.emit('showPopAlert', {
        description: '온도조절기가 교체되었습니다.',
        okCallback: () => router.go(-1),
        cancelCallback: () => router.go(-1),
      });
      return;
    } else if (wizardStep.value === 2) {
    } else if (wizardStep.value === 3) {
    } else {
      return;
    }

    wizardStep.value += 1;
  } catch (err) {
    console.log(err);
    if (err?.length > 0) {
      emitter.emit('showPopAlert', {
        description: err,
      });
    }
  }
};
</script>